import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';
import ContactForm from '../components/ContactForm';

export default function KontaktPage() {
  const bookingUrl = 'https://djursmassage.app4.geckobooking.dk/site/booking.php?show=new_booking&icCode=69a506a6f06a0ca7022b880e8f6bcb65b11332&bId=11332&aDIfH=1&dTpl=1&sSToken=267bea05a53684a4a7d7ad2e6bae564a';

  return (
    <>
      <SEOHead
        title="Kontakt & Find Os | Djurs Massage"
        description="Find Djurs Massage på Poppelvej 52 i Ryomgård. Ring på tlf. 28 58 39 07, send en besked eller book din behandling online. Vi er klar til at hjælpe."
        ogImage="https://assets.auxodev.dk/assets/5be3e3b2-e9a5-4c06-aea6-01d1054a5d99/djurs-massage-klinik-ryomgaard.jpg"
      />

      {/* Clean page header - NO container box, NO paragraph above heading */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 pb-6">
        <div className="max-w-3xl">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#1E3A5F] font-serif leading-tight">
            Kontakt Djurs Massage
          </h1>
          <p className="text-slate-700 text-sm sm:text-base mt-2 leading-relaxed">
            Har du spørgsmål til en behandling, ønsker du rådgivning om hvad der vil passe bedst til dine gener, eller vil du høre mere om vores firmaordning? Kontakt os endelig – vi svarer hurtigst muligt.
          </p>
        </div>
      </div>

      {/* Main Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
          {/* Left: Contact Form (Allowed on contact page) */}
          <div className="lg:col-span-7">
            <ContactForm
              title="Kontakt os"
              subtitle="Har du spørgsmål? Udfyld kontaktformularen og vi vender tilbage til dig hurtigst muligt."
            />
          </div>

          {/* Right: Contact Information - STRICTLY NO BOX BEHIND CONTACT INFO, NO BOX BEHIND ICONS */}
          <div className="lg:col-span-5 space-y-8 pt-2">
            <div>
              <h2 className="text-xl sm:text-2xl font-bold text-[#1E3A5F] font-serif mb-4">
                Beliggenhed & Kontaktoplysninger
              </h2>

              {/* Clean contact list directly on page without box or icon containers */}
              <div className="space-y-4 text-sm text-slate-700">
                <div className="flex items-start gap-3">
                  <i className="fa-solid fa-location-dot text-[#C9A770] text-base mt-1 shrink-0" aria-hidden="true" />
                  <div>
                    <div className="font-bold text-[#1E3A5F] text-base">Djurs Massage</div>
                    <p>Poppelvej 52</p>
                    <p>8550 Ryomgård, Danmark</p>
                    <p className="text-xs text-slate-500 mt-0.5">CVR: 28053150</p>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <i className="fa-solid fa-phone text-[#C9A770] text-base shrink-0" aria-hidden="true" />
                  <div>
                    <a
                      href="tel:28583907"
                      className="font-bold text-base text-[#1E3A5F] hover:text-black transition-colors whitespace-nowrap"
                    >
                      28 58 39 07
                    </a>
                    <span className="block text-xs text-slate-500 font-medium">SMS foretrækkes</span>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <i className="fa-solid fa-envelope text-[#C9A770] text-base shrink-0" aria-hidden="true" />
                  <div>
                    <a
                      href="mailto:djursmassage@gmail.com"
                      className="font-medium text-[#1E3A5F] hover:text-black transition-colors whitespace-nowrap"
                    >
                      djursmassage@gmail.com
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-3">
                  <i className="fa-brands fa-facebook-f text-[#C9A770] text-base shrink-0" aria-hidden="true" />
                  <div>
                    <a
                      href="https://facebook.com/djursmassage.dk"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-medium text-[#1E3A5F] hover:text-black transition-colors"
                    >
                      facebook.com/djursmassage.dk
                    </a>
                  </div>
                </div>
              </div>

              {/* Foretrækker skriftlig henvendelse & Venteliste */}
              <div className="mt-6 p-4 bg-amber-50/40 border-l-4 border-[#C9A770] border-y border-r border-[#E8E1D5] space-y-2 text-xs sm:text-sm text-slate-800">
                <div className="font-bold text-[#1E3A5F] flex items-center gap-2">
                  <i className="fa-solid fa-pen-to-square text-[#C9A770]" aria-hidden="true" />
                  <span>Henvendelse foretrækkes på skrift</span>
                </div>
                <p className="text-slate-700 leading-relaxed">
                  Da jeg ofte står midt i en behandling og har fokus på klienten, foretrækker jeg henvendelser på skrift – via kontaktformularen her, på e-mail eller via SMS på 28 58 39 07. Så svarer jeg så hurtigt som muligt.
                </p>
                <div className="pt-1 text-slate-700">
                  <strong className="text-[#1E3A5F]">Ingen ledig tid i online booking?</strong> Benyt gerne <strong>ventelisten</strong> i bookingsystemet eller send en besked med dine ønskede dage og tidspunkter.
                </div>
              </div>

              <div className="pt-5 flex flex-wrap gap-3">
                <a
                  href="https://maps.google.com/maps?q=Poppelvej%2052%2C%208550%20Ryomg%C3%A5rd%2C%20Danmark"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 sm:px-5 sm:py-2.5 bg-white border border-[#D8CDBE] text-[#1E3A5F] text-xs font-semibold hover:shadow-xs transition-shadow"
                >
                  <i className="fa-solid fa-map-location-dot text-[#C9A770]" aria-hidden="true" />
                  <span>Åbn i Google Maps</span>
                </a>
                <a
                  href={bookingUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-4 py-2 sm:px-5 sm:py-2.5 bg-[#1E3A5F] text-white text-xs font-semibold rounded-full hover:shadow-md transition-shadow"
                >
                  <i className="fa-solid fa-calendar-check text-[#C9A770]" aria-hidden="true" />
                  <span>Gå til online booking</span>
                </a>
              </div>
            </div>

            {/* Firmaordning link info directly on page */}
            <div className="pt-6 border-t border-[#E8E1D5] space-y-2">
              <h3 className="text-lg font-bold text-[#1E3A5F] font-serif">
                Interesseret i firmaordning?
              </h3>
              <p className="text-xs sm:text-sm text-slate-700 leading-relaxed">
                Vi tilbyder skræddersyede massageordninger til virksomheder – enten direkte hos jer (min. 4 timer) eller i klinikken via bruttolønsordning for medarbejderne.
              </p>
              <div className="pt-1">
                <Link
                  to="/kontakt/firmaordning"
                  className="inline-flex items-center gap-1.5 text-xs font-bold text-[#1E3A5F] hover:text-black transition-colors"
                >
                  <span>Læs mere om firmaordning →</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
